import { IconPropsType } from '..';

export const ArrowRightLongIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.333374 4.5963H7.68337L5.82721 6.46296L6.55754 7.19446L9.66671 4.0783L6.55521 0.966797L5.82487 1.6983L7.68337 3.5603H0.333374V4.5963Z"
      fill="#6A6F85"
    />
  </svg>
);
